export const getGiftRecipientName = (item) => {
  if (!item?.gift?.username) {
    return "";
  }

  return String(item.gift.username).trim();
};

export const isGiftPendingAcceptance = (item) =>
  item?.gifted === "선물발신" && !getGiftRecipientName(item);

export const getGiftStatusLabel = (item) => {
  if (!item?.gifted) {
    return null;
  }

  return isGiftPendingAcceptance(item) ? "수락 대기중" : "선물완료";
};

export const getPurchaseGiftBadgeLabel = (item) =>
  item?.gifted ? "선물됨" : null;

export const canCancelSentGift = (item) => item?.gifted === "선물발신";

export const getReservationEffectiveCancelAmount = (reservation) => {
  const explicitAmount = Number(reservation?.effectiveCancelAmount);

  if (Number.isFinite(explicitAmount)) {
    return explicitAmount;
  }

  const cancelAmount = Number(reservation?.cancelAmount ?? 0);
  const refundableOptionAmount = Array.isArray(reservation?.options)
    ? reservation.options
      .filter((item) => item?.state !== "사용함")
      .reduce((sum, item) => sum + Number(item?.price ?? 0), 0)
    : 0;

  return cancelAmount + refundableOptionAmount;
};

const parseDateValue = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const isReservationCancelFeeGraceActive = (reservation, now = new Date()) => {
  if (typeof reservation?.cancelFeeGraceActive === "boolean") {
    return reservation.cancelFeeGraceActive;
  }

  const orderDate = parseDateValue(reservation?.orderDate);
  const referenceDate = parseDateValue(now);

  if (!orderDate || !referenceDate) {
    return false;
  }

  const elapsedMs = referenceDate.getTime() - orderDate.getTime();
  return elapsedMs >= 0 && elapsedMs <= 60 * 60 * 1000;
};

export const getReservationCancelConfirmMessage = (reservation, now = new Date()) => {
  const amount = getReservationEffectiveCancelAmount(reservation);
  const lines = [`예약 취소금액은 ${amount.toLocaleString()}원입니다.`];

  if (isReservationCancelFeeGraceActive(reservation, now)) {
    lines.push("구매 1시간 이내 취소로 환불규정 없이 전액 환불됩니다.");
  }

  lines.push("정말로 취소하시겠습니까?");
  return lines.join("\n");
};

export const getTicketPurchaseActions = (ticket) => {
  const canManageTicket = ticket?.state === "사용안함" && !ticket?.gifted;

  return {
    showDetail: true,
    showGift: canManageTicket,
    showRefund: canManageTicket && Boolean(ticket?.isCancelable),
    showStaffUse: false,
  };
};

export const getReservationPurchaseActions = (reservation) => {
  const canManageReservation =
    reservation?.state === "예약" && !reservation?.gifted;

  return {
    showDetail: true,
    showDateChange: canManageReservation,
    showGift: canManageReservation,
    showOptions: canManageReservation,
    showCancel: canManageReservation,
  };
};
